import * as v from 'valibot'
import * as http from '@/util/http'

export const AcademicCourseSchema = v.object({
  id: v.number(),
  name: v.string(),
  isActive: v.boolean(),
})

export const AcademicProgramSchema = v.object({
  id: v.number(),
  name: v.string(),
  isActive: v.boolean(),
  programType: v.union([v.literal('KOSEN_REGULAR'), v.literal('KOSEN_ADVANCED')]),
  durationYears: v.number(),
})

export const SchoolSchema = v.object({
  id: v.number(),
  name: v.string(),
  isActive: v.boolean(),
  institutionType: v.union([v.literal('National'), v.literal('Public'), v.literal('Private')]),
})

export const EducationHistorySchema = v.object({
  id: v.number(),
  programType: v.union([v.literal('KOSEN_REGULAR'), v.literal('KOSEN_ADVANCED')]),
  school: SchoolSchema,
  academicProgram: v.nullable(AcademicProgramSchema),
  academicCourse: v.nullable(AcademicCourseSchema),
  enrollmentStartDate: v.pipe(
    v.string(),
    v.isoDate(),
    v.transform((s) => new Date(s))
  ),
  enrollmentEndDate: v.optional(
    v.pipe(
      v.string(),
      v.isoDate(),
      v.transform((s) => new Date(s))
    )
  ),
})

export const BookmarkedCompanySummarySchema = v.object({
  id: v.number(),
  name: v.string(),
  url: v.optional(v.string()),
  establishedDate: v.optional(
    v.pipe(
      v.string(),
      v.isoDate(),
      v.transform((s) => new Date(s))
    )
  ),
  capital: v.nullable(v.number()),
  employeeCount: v.nullable(v.number()),
  isActive: v.boolean(),
  bookmarkedAt: v.pipe(
    v.string(),
    // v.isoDateTime(),
    v.transform((s) => new Date(s))
  ),
})

export const UserSummarySchema = v.object({
  id: v.number(),
  email: v.pipe(v.string(), v.email()),
  isActive: v.boolean(),
  lastName: v.string(),
  lastNameFurigana: v.string(),
  firstName: v.string(),
  firstNameFurigana: v.string(),
  birthdate: v.optional(
    v.pipe(
      v.string(),
      v.isoDate(),
      v.transform((s) => new Date(s))
    )
  ),
  targetEmploymentYear: v.nullable(v.number()),
  educationHistories: v.array(EducationHistorySchema),
  bookmarkedCompanies: v.array(BookmarkedCompanySummarySchema),
  createdAt: v.optional(
    v.pipe(
      v.string(),
      // v.isoDateTime(),
      v.transform((s) => new Date(s))
    )
  ),
})

export type UserSummary = v.InferOutput<typeof UserSummarySchema>

export async function fetchUserSummaries(): Promise<UserSummary[]> {
  try {
    const { data } = await http.get('/api/v1/admin/user')
    const result = v.safeParse(v.array(UserSummarySchema), data)

    if (!result.success) {
      console.error('Validation failed:', result.issues)
      throw new Error('Invalid API response format')
    }

    return result.output
  } catch (error) {
    console.error('Failed to fetch user summaries:', error)
    throw error
  }
}
